import { MouseEvent } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'

import { EPOCH_TIME_MS } from 'src/constants'

const timeframes = [
  { title: '24H', value: EPOCH_TIME_MS.ONE_DAY },
  { title: '1W', value: EPOCH_TIME_MS.ONE_WEEK },
  { title: '1M', value: EPOCH_TIME_MS.ONE_MONTH },
  { title: '6M', value: EPOCH_TIME_MS.SIX_MONTHS },
  { title: '1Y', value: EPOCH_TIME_MS.ONE_YEAR },
  { title: 'ALL', value: 0 },
]

interface ITimeframeButtonsProps {
  timeframe: number
  handleTimeframeChange: (event: MouseEvent, newTimeframe: number) => void
}

const TimeframeButtons = ({ timeframe, handleTimeframeChange }: ITimeframeButtonsProps) => {
  return (
    <div>
      <ToggleButtonGroup
        size="small"
        color="primary"
        value={timeframe}
        exclusive
        onChange={handleTimeframeChange}
        aria-label="Timeframe"
      >
        {timeframes.map((timeframe) => (
          <ToggleButton key={timeframe.value} value={timeframe.value}>
            {timeframe.title}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </div>
  )
}

export { TimeframeButtons }
